export const environment = {
  production: false,
  apiBaseUrl: '/php/login/function.php',
  tenantConfigUrl: '/php/tenant/function.php',
  menuConfigUrl: '/php/food-menu/function.php',
  orderUrl: '/php/food-order-public/function.php',
  adminAuth: '/dummy/admin-user.json',
  logging: true,
  analyticsEnabled: false,
  gtmId: 'GTM-KVM8N3LF',
  gtmEnv: {
    auth: '4G8wbkDLtQ-sySMx68kzQQ',
    preview: 'env-23',
    cookiesWin: 'x',
  },
  useDummyTenantData: false,
};
